import { useEffect } from "react";
import { XCircle } from "lucide-react";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";

export default function OrderCancelled() {
  useEffect(() => {
    document.title = "Paiement annulé | ClimNova";
  }, []);
  return (
    <div data-testid="order-cancelled-page">
      <Header />
      <main className="bg-ice-soft min-h-[70vh] flex items-center">
        <div className="container-x max-w-2xl py-16">
          <div className="order-card p-8 sm:p-12 flex flex-col items-center text-center gap-5">
            <XCircle className="w-14 h-14 text-orange-600" />
            <h1 data-testid="payment-cancelled-title" className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Paiement annulé</h1>
            <p className="text-slate-600">Votre paiement n'a pas été finalisé et aucun montant n'a été débité. Vous pouvez reprendre votre commande à tout moment, ou demander à être rappelé par un conseiller.</p>
            <a href="/#commander" data-testid="cancelled-back-order" className="btn-heat mt-2">Reprendre ma commande</a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
